import {Spin} from 'antd'

export const LoadingState = () => (
  <div className="flex h-screen items-center justify-center">
    <Spin size="large" />
  </div>
)
